import { render, staticRenderFns } from "./ModalShare.vue?vue&type=template&id=21ab6e66&scoped=true&"
import script from "./ModalShare.vue?vue&type=script&lang=js&"
export * from "./ModalShare.vue?vue&type=script&lang=js&"
import style0 from "./ModalShare.vue?vue&type=style&index=0&id=21ab6e66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ab6e66",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21ab6e66')) {
      api.createRecord('21ab6e66', component.options)
    } else {
      api.reload('21ab6e66', component.options)
    }
    module.hot.accept("./ModalShare.vue?vue&type=template&id=21ab6e66&scoped=true&", function () {
      api.rerender('21ab6e66', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/Modal/ModalShare.vue"
export default component.exports